module.exports = __webpack_public_path__ + "media/assets/img/flags/sq-AL-bf107d31e02b7d9afff0cd984beccfaa.png";